import { Component, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ProfileService } from '../../../../services/profile.service';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { UserService } from '../../../../services/user';
import { ItemsService } from '../../../../services/items.service';
import { ClientsService } from '../../../../services/clients.service';

const CATEGORY_NAMES: Record<string, string> = {
  '0': 'soft food',
  '1': 'soft food can',
  '2': 'dry food',
  '3': 'bird food',
  '4': 'medicine',
  '5': 'supplement',
  '6': 'accessories',
  '7': 'toy',
  '8': 'grooming',
  '9': 'house',
  '10': 'care',
  '11': 'treats',
  '12': 'training pads',
  '13': 'bags',
  '14': 'cleaning tools',
  '15': 'litter'
};

@Component({
  selector: 'app-myclientspagemobile',
  templateUrl: './myclientspagemobile.component.html',
  styleUrl: './myclientspagemobile.component.scss'
})
export class MyclientspagemobileComponent {
  @Input() isProfile: string = '';

  allData: any[] = [];
  allWareHouses: any[] = [];

  warehouseId: any;
  selectedWarehouseName: string = '';

  userId: any;
  accountType!: string;
  isAdmin: boolean = false;
  isSubAdmin: boolean = false;
  isWarehouse: boolean = false;
  warehouseIsStore: boolean = false;

  contentReady: boolean = true;
  isLoadingMore: boolean = false;
  noData: boolean = false;

  stockTotal: any = 0;
  totalItems: any = 1;
  totaldebit: any = 0;

  page: number = 1;
  perPage: number = 10;

  searchKey: string = '';
  searching: boolean = false;
  searched: boolean = false;

  isAr: boolean = localStorage.getItem('language') === 'ar';

  popupType: 'orders' | 'products' | null = null;
  showClientPopup: boolean = false;
  selectedOrders: any[] = [];
  selectedProducts: any[] = [];
  popupTitle: string = '';

  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(() => this.accountType === '1' || this.accountType === '10')
  );

  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(() => this.accountType === '6')
  );

  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private _profileService: ProfileService,
    private _userService: UserService,
    private _orders: ItemsService,
    private excelExportService: ExcelExportService
  ) {}

  ngOnInit(): void {
    this.warehouseId = localStorage.getItem('posId');

    this.getWarehouseType();

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';

        if (this.isAdmin) {
          this.getWarehouses();
        }

        if (!this.isAdmin && !this.isSubAdmin) {
          this._userService.getUserId().subscribe({
            next: (res) => {
              this.userId = res['user_id'];
              this.getAllClientsforUser(this.perPage, 1, this.userId);
            },
            error: (error) => console.error(error)
          });
        } else {
          this.getAllClients(this.perPage, 1);
        }
      },
      error: (error) => console.error(error)
    });
  }

  get hasMore(): boolean {
    return !this.searching && Number(this.page) < Number(this.totalItems || 1);
  }

  getWarehouseType(): void {
    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: (data) => {
        const type = Number(data['warehouses_type']);

        this.isWarehouse = type === 1;

        // نفس منطق الديسكتوب: Add Pet يظهر في store types
        this.warehouseIsStore = type === 2 || type === 4;
      },
      error: (error) => console.error(error)
    });
  }

  getWarehouses(): void {
    this._orders.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse || [];

        const currentWarehouse = this.allWareHouses.find(
          (el: any) => String(el.id) === String(this.warehouseId)
        );

        this.selectedWarehouseName = currentWarehouse?.name || '';
      },
      error: (error) => console.error(error)
    });
  }

  goToCreateClient(): void {
    if (this.warehouseId) {
      localStorage.setItem('posId', String(this.warehouseId));
    }

    this.router.navigate(['/createclient']);
  }

  applyWareHouse(warehouseId: any, warehouseName?: string): void {
    this.warehouseId = warehouseId;
    this.selectedWarehouseName = warehouseName || '';
    localStorage.setItem('posId', String(warehouseId));

    this.page = 1;
    this.searching = false;
    this.searchKey = '';

    this.getWarehouseType();
    this.getAllClients(this.perPage, 1);
  }

  getAllClientsforUser(perpage: any, page: any, userId: any, append: boolean = false): void {
    this.setLoadingState(append);

    this._clientsService.getClientsUserLvl(perpage, page, userId).subscribe({
      next: (data) => {
        const list = data?.['data'] || [];

        this.allData = append ? [...this.allData, ...list] : list;
        this.stockTotal = data?.['total'] || list.length;
        this.totalItems = data?.['last_page'] || 1;
        this.page = page;

        this.finishLoading();
      },
      error: (error) => {
        console.error(error);
        this.finishLoading();
      }
    });
  }

  getAllClients(perpage: any, page: any, append: boolean = false): void {
    this.setLoadingState(append);

    this._clientsService.getClients(perpage, page, this.warehouseId).subscribe({
      next: (data) => {
        const clients = data?.clients?.data || data?.data || [];

        this.allData = append ? [...this.allData, ...clients] : clients;
        this.stockTotal = data?.clients?.total || data?.total || clients.length;
        this.totalItems = data?.clients?.last_page || data?.last_page || 1;
        this.totaldebit = data?.total_debt || 0;
        this.page = page;

        this.finishLoading();
      },
      error: (error) => {
        console.error(error);
        this.finishLoading();
      }
    });
  }

  setLoadingState(append: boolean): void {
    if (append) {
      this.isLoadingMore = true;
    } else {
      this.contentReady = true;
    }

    this.noData = false;
  }

  finishLoading(): void {
    this.contentReady = false;
    this.isLoadingMore = false;
    this.noData = this.allData.length === 0;
  }

  loadMore(): void {
    if (!this.hasMore || this.contentReady || this.isLoadingMore) {
      return;
    }

    const nextPage = Number(this.page) + 1;

    if (!this.isAdmin && !this.isSubAdmin) {
      this.getAllClientsforUser(this.perPage, nextPage, this.userId, true);
    } else {
      this.getAllClients(this.perPage, nextPage, true);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  search(): void {
    if (!this.searchKey || !this.searchKey.trim()) {
      return;
    }

    this.contentReady = true;
    this.searching = true;
    this.searched = true;
    this.page = 1;

    const userId = !this.isAdmin && !this.isSubAdmin ? this.userId : null;

    this._clientsService.searchClients(this.searchKey.trim(), this.warehouseId, userId).subscribe({
      next: (data: any) => {
        this.allData = data?.clients || [];
        this.stockTotal = this.allData.length;
        this.totalItems = 1;

        this.finishLoading();
      },
      error: (error) => {
        console.error(error);
        this.finishLoading();
      }
    });
  }

  clearSearch(): void {
    this.searchKey = '';
    this.searching = false;
    this.searched = false;
    this.page = 1;

    if (!this.isAdmin && !this.isSubAdmin) {
      this.getAllClientsforUser(this.perPage, 1, this.userId);
    } else {
      this.getAllClients(this.perPage, 1);
    }
  }

  call(phone: any): void {
    if (!phone) return;
    window.open('tel:+' + phone, '_blank');
  }

  chat(phone: any): void {
    if (!phone) return;
    window.open('https://api.whatsapp.com/send?phone=2' + phone, '_blank');
  }

  accStatement(phone: any): void {
    if (!phone || !this.isWarehouse) return;

    this.router.navigate(['/accountstatement'], {
      queryParams: { phone }
    });
  }

  reOrder(clientinfo: any): void {
    localStorage.setItem('clientinfo', JSON.stringify(clientinfo));
    this.checkWarehouseTypeForOrderRoute();
  }

  checkWarehouseTypeForOrderRoute(): void {
    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: ({ warehouses_type }) => {
        const type = Number(warehouses_type);

        if ([2, 3, 4].includes(type)) {
          this.router.navigate(['/Addorderstore']);
          return;
        }

        if (type === 1) {
          this.router.navigate(['/Addorderwarehouse']);
          return;
        }

        this.router.navigate(['/Addorder']);
      },
      error: (error) => console.error(error)
    });
  }

  addPet(id: any): void {
    if (!id) return;

    this.router.navigate(['/pets'], {
      queryParams: { id }
    });
  }

  getClientOrders(obj: any): void {
    const orders = this.parseArrayData(obj);

    this.popupType = 'orders';
    this.popupTitle = this.isAr ? 'الطلبات' : 'Orders';
    this.selectedOrders = orders;
    this.showClientPopup = true;
  }

  getClientproducts(obj: any): void {
    const products = this.parseArrayData(obj);

    this.popupType = 'products';
    this.popupTitle = this.isAr ? 'المنتجات' : 'Products';
    this.selectedProducts = products;
    this.showClientPopup = true;
  }

  parseArrayData(obj: any): any[] {
    if (!obj) return [];

    if (typeof obj === 'string') {
      try {
        obj = JSON.parse(obj);
      } catch (error) {
        console.error('Invalid JSON', error);
        return [];
      }
    }

    return Array.isArray(obj) ? obj : [];
  }

  closeClientPopup(): void {
    this.showClientPopup = false;
    this.popupType = null;
    this.selectedOrders = [];
    this.selectedProducts = [];
    this.popupTitle = '';
  }

  getCategoryName(categoryId: string): string {
    return CATEGORY_NAMES[String(categoryId)] ?? '-';
  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('orderstable', 'Orders', ['actions']);
  }

  trackByClient(index: number, item: any): any {
    return item?.id || item?.phone_number || index;
  }
}